import React from 'react';

import Page from '../../../page.jsx';
import userPropTypes from '../../../userPropTypes.js';

const VerificationRequired = ({ user }) => (
    <Page heading="Du må bekrefte din identitet">
        <div>
            <p className="r-ptl">
                For at kjøper skal kunne betale må du bekrefte din identitet
                (bli verifisert bruker).
            </p>

            <div className="r-phl r-ptl">
                <a
                    href={user.verificationUrl}
                    className="button r-mbl primary fullwidth"
                >
                    Bekreft din identitet
                </a>
            </div>
        </div>
    </Page>
);

VerificationRequired.propTypes = {
    user: userPropTypes.isRequired,
};

export default VerificationRequired;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/statusDetails/verificationRequired.jsx